module.exports = __webpack_public_path__ + "img/61.4c10e5e3.jpg";